import { useEffect } from "react";
import useEntities from "../../app/hooks/useEntities";
import useTableData from "../../app/hooks/useTableData";
import { useAppSelector } from "../../app/store";
import Filter from "../../components/filter";
import GlobalSearch from "../../components/global-search";
import ProductionTypeFilter from "../../components/production-type-filter";
import Grid from "../../components/grid";
import { AppContainer, ProductionTypeFilterContainer } from "../../styles"; // Импортируем новый стиль
import { DarkmodeStyle } from "../../styles/darkmode";
import { useSyncFiltersWithURL } from "../../app/hooks/useSyncFiltersWithURL";
import ScrollToTop from "../../components/scroll-to-top-button";

export default function TablePage() {
  const { filter } = useAppSelector(store => store.AppSlice)
  const { getData: getTableData, loading } = useTableData()
  useEntities()
  useSyncFiltersWithURL()

  useEffect(getTableData, [filter, getTableData])

  return (
    <AppContainer>
      <DarkmodeStyle />
         <ProductionTypeFilterContainer>
             <ProductionTypeFilter />
         </ProductionTypeFilterContainer>
         <Filter />
         <GlobalSearch />
         <Grid loading={loading} />
        <ScrollToTop />
     </AppContainer>
  );
}